import { gql, useMutation } from '@apollo/client'

export const SUBSCRIBE_TO_PUSH_NOTIFICATIONS = gql`
  mutation ($user_id: String!, $subscription_info: String!) {
    subscribeToPushNotifications(user_id: $user_id, subscription_info: $subscription_info)
  }
`

export const useSubscribeToPushNotifications = () => {
  const [mutate, { data, error, loading }] = useMutation(SUBSCRIBE_TO_PUSH_NOTIFICATIONS)

  return { mutate, data, error, loading }
}
